import { SubscriptionStoreState } from '../subscriptionStore';
import { getIsOnTrial } from './getIsOnTrial';
import { getIsPremium } from './getIsPremium';

export const getIsFreeUser = (state?: SubscriptionStoreState) => {
  return !getIsOnTrial(state) && !getIsPremium(state);
};
